import axiosInstance from '@/axiosInstance'
import { getApiUrl } from '@/helper'
import { URL_V2 } from '../../constatns'

export const loadMainData = async () => {
  return axiosInstance.get(`${getApiUrl()}${URL_V2}`)
}

export const loadModalData = async (name, type) => {
  return axiosInstance.get(`${getApiUrl()}${URL_V2}/modal-data/${name}/${type}`)
}
